module.exports = __webpack_public_path__ + "static/media/spin_wheel_selected_point.21d68fd8.png";